export const AUTOMATIC_RETRAINER_ID = 'AUTOMATIC_RETRAINER';
export const REVIEW_AI_AGENT_CHECKER_ID = 'REVIEW_AI_AGENT';
